import { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'src/lib/components/Button.component';
import { Pagination } from 'src/lib/components/Pagination.component';
import { Select } from 'src/lib/components/Select.component';
import { Table, TableRefObject } from 'src/lib/components/Table.component';
import { TextInput } from 'src/lib/components/TextInput.component';
import { fdelete, fpost, getUser, isUserHasRoles } from 'src/lib/fetch';
import { getSearchMap } from 'src/lib/react-router-dom/search-map';
import { ResponseDocuments } from 'src/lib/response/response';
import { AdEntity } from 'src/modules/ads/dto/ads.entity';
import { QueryAdsFilter, QueryAdsReq } from 'src/modules/ads/dto/ads.req';
import { twMerge } from 'tailwind-merge';
import { UserRole } from '../../dto/login/login.res';

export function AdsPage() {
  const eTable = useRef<TableRefObject>(null);
  const eButtonDeleteAll = useRef<HTMLButtonElement>(null);

  const [ads, setAds] = useState<ResponseDocuments<AdEntity>>();

  const setTimeoutOnChangeTextSearch = useRef<NodeJS.Timeout>();

  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const search = getSearchMap<QueryAdsFilter>(searchParams, { keyParseToNumber: { f_imported: true } });

  const currentUser = getUser();

  // サイドヘッダーオープン
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('open');
    } else {
      document.body.classList.remove('open');
    }
  }, [isOpen]);
  // サイドヘッダーオープン END

  function queryAds() {
    fpost<QueryAdsReq, typeof ads>('media/query/admin', {
      body: {
        filter: search.groupByPrefix,
        currentPage: +(search['page'] || 1) - 1,
        pageLimit: 20,
      },
      onErrorMoveToLocation: '/dashboard/logout',
    }).then((res) => setAds(res[1]));
  }

  function handleButtonDelete(input: Partial<AdEntity>) {
    fdelete(`media/getMedia/${input._id}`, {
      onErrorMoveToLocation: '/dashboard/logout',
    }).then(() => {
      queryAds();
    });
  }

  useEffect(() => {
    queryAds();
  }, [searchParams]);

  return (
    <div className="flex flex-row flex-wrap px-16 py-10 dashboard-wrap-top">
        <style>
            {`@media screen and (max-width: 576px) { 
              /* テーブル */
              table th:first-child,
              table td:first-child {
                width: calc(60px + 40px + (15px*2));
              }
              table th:nth-child(n+2),
              table td:nth-child(n+2) {
                width: calc(60px + 40px + (15px*2));
              }
              table th:nth-child(5),
              table td:nth-child(5) {
                width: calc(200px + (15px*2));
              }
              table th:nth-child(5) a,
              table td:nth-child(5) a {
                width: 95%;
              }
              table th:last-child,
              table td:last-child {
                width: calc(40px + (15px*2));
                text-align: center;
              }
            }
            @media screen and (min-width: 577px) and (max-width: 768px) {
              table th:first-child,
              table td:first-child {
                width: calc(60px + 40px + (15px*2));
              }
              table th:last-child,
              table td:last-child {
                width: calc(40px + (15px*2));
                text-align: center;
              }
            }`}
      </style>
      {isUserHasRoles([UserRole.ADMIN]) && (
        <style>
              {`@media screen and (max-width: 576px) { 
                /* テーブル */
                table th:first-child,
                table td:first-child {
                  width: calc(20px + (15px*2));
                  text-align: center;
                }
              }
              @media screen and (min-width: 577px) and (max-width: 768px) {
                table th:first-child,
                table td:first-child {
                  width: calc(20px + (15px*2));
                  text-align: center;
                }
              }`}
        </style>
      )}
        <div className='login-header-wrap'>
          <h1 className="text-2xl">素材リスト</h1>
          <div className={`dashboard-btn-div cp_hmenuac01${isOpen ? ' active' : ''}`} onClick={handleClick}><span className="cp_bar"></span></div>
        </div>
      <span
        className="w-full border-b border-slate-800 dashboard-border-span"
        style={{
          minWidth: '24rem',
        }}></span>

      <div className="mt-2 flex basis-full flex-wrap items-center gap-4">
        <Select
          className="rounded-md pr-12"
          labelProps={{
            children: '作成タイプ',
            className: 'mb-0 mr-4 whitespace-nowrap',
          }}
          defaultValue={String(search.groupByPrefix.imported || 1)}
          containerProps={{
            className: 'flex items-center justify-end',
          }}
          onChange={(e) => {
            setSearchParams((prevParams) => {
              prevParams.set('f_imported', e.target.value);

              return prevParams;
            });
          }}>
          <option value="1">すべて</option>
          <option value="2">インポート</option>
          <option value="3">手動作成</option>
        </Select>

        {/* <div className="flex">
          <Select
            className="rounded-md rounded-r-none border-r-0 pr-12"
            labelProps={{
              children: '検索タイプ',
              className: 'mb-0 mr-2 whitespace-nowrap',
            }}
            defaultValue={String(search.groupByPrefix.imported || 1)}
            containerProps={{
              className: 'flex items-center justify-end',
            }}
            onChange={(e) => {
              setSearchParams((prevParams) => {
                prevParams.set('f_searchType', e.target.value);
                return prevParams;
              });
            }}>
            <option value="ALL">あらゆる分野で</option>
            <option value="EMAIL">ユーザーの電子メールで</option>
            <option value="USER_NAME">ユーザー名</option>
          </Select>

          <TextInput
            className="rounded-l-none"
            type="text"
            placeholder="探す..."
            labelProps={{
              className: 'm-0',
            }}
            defaultValue={search.groupByPrefix.searchString}
            onChange={(e) => {
              clearTimeout(setTimeoutOnChangeTextSearch.current);
              setTimeoutOnChangeTextSearch.current = setTimeout(() => {
                setSearchParams((prevParams) => {
                  prevParams.set('f_searchString', e.target.value);
                  return prevParams;
                });
              }, 1111);
            }}
          />
        </div> */}

        <Button
          className="ml-auto whitespace-nowrap bg-black px-4 text-white dashboard-button"
          onClick={(e) => {
            navigate('create');
          }}>
          <svg className="mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
          手動作成
        </Button>
        {isUserHasRoles([UserRole.ADMIN]) && (
          <Button
            className="hidden whitespace-nowrap bg-slate-50 px-4 text-red-500"
            ref={eButtonDeleteAll}
            onClick={() => {
              fdelete<{ listMedia: string[] }>('media/deleteMedias', {
                body: {
                  listMedia: Array.from(eTable.current?.selected().keys() || []).map((i) => ads?.data[i]._id || ''),
                },
              }).then(() => {
                const headCheckbox = eTable.current?.headCheckbox();

                headCheckbox && (headCheckbox.checked = false);

                eButtonDeleteAll.current &&
                  (eButtonDeleteAll.current.className = twMerge(eButtonDeleteAll.current.className, 'hidden'));

                queryAds();
              });
            }}>
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" /> <line x1="4" y1="7" x2="20" y2="7" />{' '}
              <line x1="10" y1="11" x2="10" y2="17" /> <line x1="14" y1="11" x2="14" y2="17" />{' '}
              <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />{' '}
              <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
            </svg>
            すべて削除
          </Button>
        )}
      </div>
      {ads ? (
        <div className="relative mt-4 flex w-full basis-full flex-wrap items-center gap-2 overflow-x-auto rounded-md border p-4 shadow-md dashboard-table-div">
          <Table
            headCellProps={{
              className: 'whitespace-nowrap',
            }}
            headCellData={['キャプチャ', '媒体', '広告主', '遷移先', '時間', '']}
            cellData={ads.data.map((ad) =>
              [
                (() => {
                  let captureURL = new URL(`http://${window.location.host}/marker-icon.png`);
                  try {
                    if (ad) captureURL = new URL(ad.capture);
                  } catch {
                    /* empty */
                  }

                  captureURL.searchParams.delete('dl');
                  captureURL.searchParams.append('raw', '1');

                  const isVideoUrl =
                    '|.ty+|.str|.swf|.aep|.mkv|.pz|.plot|.sfd|.kine|.drp|.psv|.prproj|.piv|.veg|.vproj|.inp|.pic|.anm|.cpvc|.plotdoc|.scm|.wlmp|.msdvd|.aec|.bik|.kdenlive|.mswmm|.dcr|.webm|.amc|.scm|.vpj|.wpl|.dir|.mp4|.fcp|.fbr|.evo|.srt|.dcr|.vob|.mse|.rmvb|.sbt|.clpi|.flc|.sub|.ssf|.vsp|.pac|.ifo|.3gp|.mxf|.cine|.dmsm|.rec|.camproj|.mvd|.ivr|.dmx|.vp6|.vtt|.alpx|.sqz|.m4u|.dpa|.av1|.wmmp|.meta|.tsv|.mpeg|.trp|.swi|.gts|.rcd|.db2|.aepx|.mgv|.screenflow|.mvp|.mpv|.amx|.mani|.d3v|.hdmov|.rms|.video|.ismv|.3gp2|.viv|.wmv|.asf|.vc1|.ogv|.flv|.psh|.dmsm3d|.ncor|.pmf|.ser|.jtv|.ale|.mys|.zm2|.siv|.meps|.rcut|.g2m|.arcut|.exi|.gfp|.tvshow|.mpsub|.m2ts|.dv4|.mproj|.dxr|.mp4v|.mp4.infovid|.ts|.mob|.dat|.m1v|.cme|.mp5|.idx|.scc|.zmv|.iva|.mj2|.psb|.m2t|.dream|.mepx|.m4v|.rm|.mpeg4|.dzm|.trec|.camrec|.tix|.theater|.smv|.mjpg|.bk2|.mnv|.wp3|.stx|.vro|.awlive|.f4p|.mpg|.xmv|.vgz|.wvm|.dash|.mov|.dzp|.dv|.tp|.mts|.pds|.int|.dvr-ms|.dvr|.tmv|.mmp|.sedprj|.pclx|.avv|.dzt|.ircp|.mv|.ppj|.ffd|.avb|.dmb|.cst|.m4s|.zm3|.ktn|.kmproject|.fbr|.izz|.sfvidcap|.camv|.fli|.vii|.qtch|.m75|.mep|.izzy|.vid|.264|.bnp|.playlist|.wvx|.avchd|.dav|.sbk|.cpi|.3mm|.vep|.h264|.3g2|.mp2v|.xesc|.sfera|.m15|.264|.mvp|.rdb|.mpeg2|.bsf|.jdr|.60d|.xvid|.lvix|.d2v|.ddat|.san|.pgi|.890|.yuv|.aaf|.ism|.movie|.g64x|.g64|.media|.f4v|.mpv2|.mpl|.3gpp|.jss|.pdrproj|.mp21|.mvex|.tbc|.r3d|.qtl|.mmv|.wve|.dck|.hdv|.mk3d|.dnc|.xlmv|.rsx|.tsp|.pro|.f4f|.m4f|.vcr|.bdmv|.vp3|.divx|.hevc|.m2p|.ogm|.nut|.moi|.swt|.smk|.wcp|.nuv|.rv|.k3g|.spl|.ogx|.wm|.xml|.kmv|.avi|.dpg|.bu|.ced|.dvdmedia|.3gpp2|.rum|.tvlayer|.tdt|.lrec|.3p2|.exo|.wrf|.mpe|.787|.arf|.wmd|.rmd|.bdt3|.mtv|.flic|.tivo|.m2a|.vp7|.bmc|.nfv|.tvs|.lsx|.lrv|.mpg4|.gvi|.moov|.aqt|.tpd|.dmsd|.rmp|.aetx|.jmv|.mjp|.prel|.zoom|.wxp|.f4m|.mvc|.v264|.nvc|.asx|.imovieproj|.y4m|.bvr|.movie|.ttxt|.irf|.ajp|.ftc|.ave|.avp|.smil|.fvm|.wtv|.bdm|.tvrecording|.otrkey|.ntp|.mve|.mv8|.axv|.wot|.m4e|.avd|.prtl|.imovielibrary|.m2v|.vse|.pjs|.avs|.vcv|.flh|.sub|.evo|.m21|.pxv|.hkm|.n3r|.vr|.rcrec|.sbz|.tpr|.imoviemobile|.roq|.fpdx|.peg|.vbc|.sdv|.rvid|.vdr|.rvl|.bmk|.plproj|.zeg|.mpgindex|.ismc|.cmproj|.photoshow|.cmmtpl|.zm1|.gxf|.tod|.tda3mt|.ivf|.dvx|.dvt|.braw|.projector|.lfpackage|.ttml|.m21|.ssm|.orv|.qt|.insv|.vivo|.mpeg1|.aegraphic|.mpl|.sec|.mt2s|.wmx|.edl|.par|.sec|.vcpf|.qtm|.rmd|.yog|.w32|.pns|.gifv|.gcs|.amv|.xel|.crec|.vix|.clk|.nsv|.av|.thp|.pvr|.am|.ravi|.pssd|.dv-avi|.fcproject|.vfz|.smi|.anim|.ssa|.vfw|.seq|.proqc|.fcarch|.byu|.m1pg|.blz|.mpc|.vs4|.vlab|.bs4|.qsv|.mxv|.vmd|.modd|.mvb|.mpls|.dif|.mod|.tp0|.qtz|.viewlet|.xfl|.bix|.gl|.spryzip|.wsve|.vem|.vdo|.ezt|.jts|.axm|.dmss|.imovieproject|.aet|.cmrec|.aecap|.vf|.dad|.dlx|.ffm|.pro4dvd|.cmmp|.vdx|.xej|.mpg2|.cvc|.svi|.exp|.usf|.stl|.smi|.moff|.fbz|.lsf|.msh|.fvt|.jv|.seq|.dce|.cmv|.cip|.h261|.ivs|.scn|.pva|.eyetv|.avm|.h265|.lxf|.gom|.avs|.mqv|.wgi|.rcproject|.rmv|.avr|.eye|.mjpeg|.dmsd3d|.tdx|.ty|.ismclip|.mvy|.avs|.wfsp|.anydesk|.bik2|.vmlf|.cam|.vmlt|.cdxl|.drc|.vsr|.vp5|.anx|.pmp|.pro5dvd|.el8|.cx3|.camtemplate|.skm|.avc|.bdt2|.rts|.qtindex|.gvp|.mp21|.tid|.qsmd|.rp|.mpf|.sml|.p64|.movie|.lvf|.jnr|.flx|.vsh|.h263|.av3|.kux|.vft|.grasp|.ml20|.h262|.paf|.dsy|.tgv|.tgq|.rpl|.rl2|.mvi|.pmv|.cel|.rts|.pjr|'.includes(
                      `|.${captureURL.pathname.split('.').at(-1) || ''}|`,
                    );

                  return ad.material === '静止画' && !isVideoUrl ? (
                    <img
                      src={captureURL.href}
                      style={{
                        height: '8rem',
                      }}
                      loading={'lazy'}
                      className="cursor-pointer object-cover transition duration-1000 ease-in-out group-hover:scale-125 group-hover:brightness-50"
                    />
                  ) : (
                    <div className="max-w-xs">
                      <ReactPlayer url={captureURL.href} width="auto" height="8rem" />
                    </div>
                  );
                })(),
                ad.mediaSource,
                ad.advertiser,
                <a
                  href={ad.transitionDestination}
                  target="_blank"
                  className="inline-block max-w-[16rem] overflow-hidden text-ellipsis whitespace-nowrap font-medium text-blue-500 hover:underline"
                  onClick={(e) => {
                    e.stopPropagation();
                    return true;
                  }}>
                  {ad.transitionDestination}
                </a>,
                <span className="whitespace-nowrap">
                  {ad.year} 年 {ad.month} 月 {ad.day} 日
                </span>,
              ].concat(
                currentUser?.role === 'ADMIN' ? (
                  <a
                    href="#"
                    className={
                      'font-medium text-red-500 hover:underline dark:text-blue-500' +
                      (currentUser?.role === 'ADMIN' ? '' : ' cursor-not-allowed')
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      // return
                      handleButtonDelete({ _id: ad._id });
                      return true;
                    }}>
                    削除
                  </a>
                ) : (
                  ''
                ),
              ),
            )}
            rowProps={{
              onClick: (e) => {
                navigate(`${ads.data.at(+(e.currentTarget.id.split('-').at(-1) || 0))?._id}`);
              },
            }}
            checkboxProps={{
              onChange: () => {
                if (eTable.current?.selected().size) {
                  eButtonDeleteAll.current &&
                    (eButtonDeleteAll.current.className = twMerge(eButtonDeleteAll.current.className, 'block'));
                } else
                  eButtonDeleteAll.current &&
                    (eButtonDeleteAll.current.className = twMerge(eButtonDeleteAll.current.className, 'hidden'));
              },
              onClick: (e) => {
                e.stopPropagation();
              },
            }}
            hideCheckbox={isUserHasRoles([UserRole.USER])}
            ref={eTable}
          />
          <div className="basis-full text-center">
            <Pagination
              total={Math.ceil(ads.total / (ads.pageLimit || 1))}
              hops="lastpoint"
              defaultPageValue={+(search['page'] || 1)}
              onPageChange={(page) => {
                setSearchParams((prevParams) => {
                  prevParams.set('page', page.toString());
                  return prevParams;
                });
              }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
